import { Injectable, Inject, Renderer2 } from "@angular/core";
import { PoTableColumn } from "@po-ui/ng-components";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class OrcamentoListService {
  //
  urlQRCode = `${environment.API}protheus/pix`;
  urlOrcamentos = `${environment.API}listaOrcamento`;
  urlSaldo = `${environment.API}saldo`;
  urlCliente = `${environment.API}clientes`;
  urlcabOrcamento = `${environment.API}cabOrcamento`;
  urlVendaOrcamento = `${environment.API}protheus/venda`;
  urlItensOrcamento = `${environment.API}itensorcamento`;
  urlEmail = `${environment.API}email`;
  urlOrdemColeta = `${environment.API}ordemcoleta`;
  urlmailOrcamento = `${environment.API}mailorcamento`;
  urlMailPagOnline = `${environment.API}mailpagonline`;
  urlPagamentoOnline = `${environment.API}pagonline`;
  urlEstoque = `${environment.API}protheus/estoque`;
  urlNCC = `${environment.API}protheus/ncc`;
  urlXmlDanfe = `${environment.API}protheus/danfe`;
  urlBoleto = `${environment.API}protheus/boleto`;
  urlChassi = `${environment.API}protheus/chassi`;
  urlStatusOrc = `${environment.API}protheus/statuspagamento`;
  urlParam = `${environment.API}parametro/0301/`;
  get headers(): HttpHeaders {
    return new HttpHeaders({ authorization: sessionStorage.getItem("token") || "" });
  }
  renderer: any;

  constructor(private http: HttpClient) { }
  //segmto: req.body[0].segmto,
  //cgc: req.body[0].cgc,
  getOrcamentoList(
    id: string | String,
    segmto: string,
    cgc: string
  ): Observable<any> {
    let adm = "U";
    return this.http.post(
      this.urlOrcamentos,
      { id, segmto, cgc, adm },
      { headers: this.headers }
    );
  }

  salvaStatusProtheus(
    EMPRESA: string,
    NUMORC: any,
    STATUS: number
  ): Observable<any> {
    return this.http.post(
      this.urlStatusOrc,
      { EMPRESA, NUMORC, STATUS },
      { headers: this.headers }
    );
  }

  getChassisColumns(): Array<PoTableColumn> {
    return [
      { property: "item", type: "number", width: "5%" },
      { property: "codigo", type: "number", width: "30%" },
      {
        property: "descricao",
        type: "string",
        width: "50%",
        label: "Descrição",
      },
      { property: "chassi", type: "number", width: "30%" },
      { property: "cor", type: "string", width: "20%" },
      { property: "cilindrada", type: "number", width: "10%" },
      { property: "modelo", type: "number", width: "20%" },
      { property: "fab", type: "number", width: "20%" },
      { property: "motor", type: "number", width: "20%" },
      { property: "nuance", type: "string", width: "35%" },
    ];
  }

  getTiposColumns(): Array<PoTableColumn> {
    return [
      { property: "Tipo", width: "60%" },
      { property: "Valor", width: "40%" },
    ];
  }

  public createJsScript(
    renderer: Renderer2,
    token: string,
    valor: string,
    orderid: string,
    nome: string,
    sobrenome: string,
    tipoDoc: string,
    documento: string,
    email: string,
    telefone: string,
    endereco: string,
    num: string,
    bairro: string,
    cidade: string,
    estado: string,
    cep: string,
    disabled: string
  ): HTMLScriptElement {
    const script = document.createElement('script');
    script.async = true;
    script.src = `${environment.getnetLoaderUrl}`;
    script.setAttribute('data-getnet-sellerid', `${environment.getnetSellerid}`);
    // script.setAttribute('data-getnet-url-callback', `${environment.API}getnet/callback`);
    script.setAttribute('data-getnet-url-callback', '');
    script.setAttribute('data-getnet-token', token);
    script.setAttribute('data-getnet-payment-methods-disabled', disabled);
    script.setAttribute('data-getnet-amount', valor);
    script.setAttribute('data-getnet-customerid', '1234');
    script.setAttribute('data-getnet-orderid', orderid);
    script.setAttribute('data-getnet-button-class', 'pay-button-getnet');
    script.setAttribute('data-getnet-installments', '6');
    script.setAttribute('data-getnet-customer-first-name', nome);
    script.setAttribute('data-getnet-customer-last-name', sobrenome);
    script.setAttribute('data-getnet-customer-document-type', tipoDoc);
    script.setAttribute('data-getnet-customer-document-number', documento);
    script.setAttribute('data-getnet-customer-email', email);
    script.setAttribute('data-getnet-customer-phone-number', telefone);
    script.setAttribute('data-getnet-customer-address-street', endereco);
    script.setAttribute('data-getnet-customer-address-street-number', num);
    script.setAttribute('data-getnet-customer-address-complementary', '');
    script.setAttribute('data-getnet-customer-address-neighborhood', bairro);
    script.setAttribute('data-getnet-customer-address-city', cidade);
    script.setAttribute('data-getnet-customer-address-state', estado);
    script.setAttribute('data-getnet-customer-address-zipcode', cep);
    script.setAttribute('data-getnet-customer-country', 'Brasil');
    script.setAttribute('data-getnet-items', '[{"name":"","description":"","value":0,"quantity":0,"sku":""}]');

    renderer.appendChild(document.body, script);
    return script;
  }

  geraNCC(
    empresa: any,
    filial: any,
    cliente: any,
    valor: any,
    orcamento: any,
    pedido: any
  ): Observable<any> {
    return this.http.post(
      this.urlNCC,
      {
        empresa: empresa,
        filial: filial,
        cliente: cliente,
        valor: valor,
        orcamento: orcamento,
        pedido: pedido,
      },
      { headers: this.headers }
    );
  }

  getMailComprovante(segmeto: string): Observable<any> {
    if (segmeto == "MOTOS") {
      return this.http.get(this.urlParam + "MV_CRMTMAI", {
        headers: this.headers,
      });
    } else if (segmeto == "VEICULOS") {
      return this.http.get(this.urlParam + "MV_CRMVMAI", {
        headers: this.headers,
      });
    } else {
      return this.http.get(this.urlParam + "MV_CRMPMAI", {
        headers: this.headers,
      });
    }
  }

  getMailComercial(segmeto: string): Observable<any> {
    if (segmeto == "MOTOS") {
      return this.http.get(this.urlParam + "MV_CRMCMOT", {
        headers: this.headers,
      });
    } else if (segmeto == "VEICULOS") {
      return this.http.get(this.urlParam + "MV_CRMCVEI", {
        headers: this.headers,
      });
    } else {
      return this.http.get(this.urlParam + "MV_CRMCPEC", {
        headers: this.headers,
      });
    }
  }

  getMailOrdemColeta(segmeto: string): Observable<any> {
    if (segmeto == "MOTOS") {
      return this.http.get(this.urlParam + "MV_CRMOMOT", {
        headers: this.headers,
      });
    } else if (segmeto == "VEICULOS") {
      return this.http.get(this.urlParam + "MV_CRMOVEI", {
        headers: this.headers,
      });
    } else {
      return this.http.get(this.urlParam + "MV_CRMOPEC", {
        headers: this.headers,
      });
    }
  }

  getValorMinimo(): Observable<any> {
    return this.http.get(this.urlParam + "MV_XVALMIN", { headers: this.headers });
  }

  getSaldo(id: number): Observable<any> {
    return this.http.post(this.urlSaldo, { id }, { headers: this.headers });
  }

  geraQRCode(
    filial: string,
    valor: string,
    pedido: any,
    orcamento: any,
    segmento: string
  ): Observable<any> {
    let val = Number(valor);

    return this.http.get(this.urlQRCode, {
      headers: this.headers,
      params: {
        Filial: filial,
        Valor: val.toFixed(2),
        Pedido: pedido,
        Orcamento: orcamento,
        Segmento: segmento,
      },
    });
  }

  consultaPIX(
    filial: string,
    cliente: string,
    loja: string,
    valor: number,
    vendedor: string,
    txid: any,
    hist: string
  ): Observable<any> {
    return this.http.post(
      this.urlQRCode,
      {
        empresa: "01",
        filial: filial,
        cliente: cliente,
        loja: loja,
        valor: valor,
        vendedor: vendedor,
        txid: txid,
        hist: hist,
      },
      { headers: this.headers }
    );
  }

  enviaXMLDanfe(email: string, nota: string, empresa: string): Observable<any> {
    var arrayNota = nota.split("-");
    return this.http.post(
      this.urlXmlDanfe,
      {
        EMPRESA: empresa,
        NOTA: arrayNota[0],
        SERIE: arrayNota[1],
        EMAIL: email,
      },
      { headers: this.headers }
    );
  }

  enviaBoleto(email: string, nota: string, empresa: string): Observable<any> {
    var arrayNota = nota.split("-");
    return this.http.post(
      this.urlBoleto,
      {
        EMPRESA: empresa,
        NOTA: arrayNota[0],
        SERIE: arrayNota[1],
        EMAIL: email,
      },
      { headers: this.headers }
    );
  }

  getChassi(nota: string, empresa: string): Observable<any> {
    var arrayNota = nota.split("-");
    return this.http.post(
      this.urlChassi,
      {
        EMPRESA: empresa,
        NOTA: arrayNota[0],
        SERIE: arrayNota[1],
      },
      { headers: this.headers }
    );
  }

  getNomeCliente(cgc: any): Observable<any> {
    return this.http.post(
      this.urlCliente,
      { cgc, tiporeq: "C" },
      { headers: this.headers }
    );
  }

  deleteCabOrcamento(id: string): Observable<any> {
    return this.http.delete(this.urlOrcamentos + "/" + id, {
      headers: this.headers,
    });
  }

  vendaOrcamento(Orcamento: object): Observable<any> {
    return this.http.post(this.urlVendaOrcamento, Orcamento, {
      headers: this.headers,
    });
  }

  enviaEmail(email: any, orcamento: any, codigo: any): Observable<any> {
    return this.http.post(
      this.urlEmail,
      {
        email: email,
        orcamento: orcamento,
        codigo: codigo,
        url: "", //'http://localhost:4200/orcamentocliente/'
      },
      { headers: this.headers }
    );
  }

  SalvaCabOrcamento(cabOrcamento: Array<any>): Observable<any> {
    return this.http.post(this.urlcabOrcamento, cabOrcamento, {
      headers: this.headers,
    });
  }

  salvaSaldo(saldo: Array<any>): Observable<any> {
    return this.http.put(this.urlSaldo, saldo, {
      headers: this.headers,
    });
  }

  getCabOrcamento(id: number): Observable<any> {
    return this.http.post(
      this.urlOrcamentos,
      {
        id: id,
      },
      { headers: this.headers }
    );
  }

  getEstoque(produto: String): Observable<any> {
    return this.http.get(this.urlEstoque + "/?produtob2=" + produto, {
      headers: this.headers,
    });
  }

  /*
  async getEstoqueP(produto: String): Promise<any> {
    const data = await this.http
      .get(this.urlEstoque + "/?produtob2=" + produto, {
        headers: this.headers,
      })
      .toPromise();
    return data;
  }*/

  getEstoqueP(Produtos: any[]): Observable<any> {
    return this.http.post(
      this.urlEstoque,
      {
        Produtos,
      },
      { headers: this.headers }
    );
  }

  envOrdemColeta(
    id: string,
    pedido: string,
    ocData: string,
    ocTransp: string,
    ocEndereco: string,
    ocMotorista: string,
    ocRg: string,
    ocTpVeic: string,
    ocPlaca: string,
    ocCapacidade: string,
    email: string,
    obsOc: string
  ): Observable<any> {
    return this.http.post(
      this.urlOrdemColeta,
      {
        id,
        pedido,
        nomedocliente: "",
        data: ocData,
        endereco: ocEndereco,
        transp: ocTransp,
        motorista: ocMotorista,
        rg: ocRg,
        tpveiculo: ocTpVeic,
        placa: ocPlaca,
        capacidade: ocCapacidade,
        produtos: [],
        email,
        obs: obsOc,
      },
      { headers: this.headers }
    );
  }

  envMailOrcamento(id: string, email: string): Observable<any> {
    return this.http.post(
      this.urlmailOrcamento,
      {
        id,
        email,
      },
      { headers: this.headers }
    );
  }

  envMailPagOn(id: string, email: string): Observable<any> {
    return this.http.post(
      this.urlMailPagOnline,
      {
        id,
        email,
      },
      { headers: this.headers }
    );
  }

  efetuaPagamento(): Observable<any> {
    return this.http.post(
      this.urlPagamentoOnline,
      {},
      { headers: this.headers }
    );
  }

  getItensOrcamento(id: number): Observable<any> {
    return this.http.post(
      this.urlItensOrcamento,
      {
        id: id,
      },
      { headers: this.headers }
    );
  }
}
